import { Stack, Typography } from "@mui/material";
import Link from "next/link";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

export const QAFooter = () => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <Stack className="mt-5">
      <Typography
        sx={{
          color: componentColors.surface.onSurface,
        }}
        className="text-base"
      >
        Have other questions?
      </Typography>

      <Typography
        style={{
          color: componentColors.surface.onSurface,
        }}
        className="text-base"
      >
        Ask our{" "}
        <Link
          style={{
            color: componentColors.primary.primary,
          }}
          href="mailto:support@pod1um.com?subject=Athlete Support"
        >
          support team
        </Link>
      </Typography>
    </Stack>
  );
};
